import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from './views/Home.vue';
import CorposSociais from './views/CorposSociais.vue';
import ContasLamfa from './views/ContasLamfa.vue';
import Diversos from './views/Diversos.vue';
import Alcafozense from './views/Alcafozense.vue';
import ComissoesFesta from './views/ComissoesFesta.vue';
import ContasFesta from './views/ContasFesta.vue';
import FotosVideos from './views/FotosVideos.vue';
import Links from './views/Links.vue';
import NotFound from './views/NotFound.vue';

const router = new VueRouter({
  routes: [
    { path: '/', component: Home },
    { path: '/corpos-sociais', component: CorposSociais },
    { path: '/contas-lamfa', component: ContasLamfa },
    { path: '/diversos', component: Diversos },
    { path: '/alcafozense', component: Alcafozense },
    { path: '/comissoes-festa', component: ComissoesFesta },
    { path: '/contas-festa', component: ContasFesta },
    { path: '/fotos-videos', component: FotosVideos },
    { path: '/links', component: Links },
    { path: '*', component: NotFound }
  ],
  scrollBehavior () {
    return { x: 0, y: 0 }
  }  
})

Vue.use(VueRouter);

export default router;
